/**
 * Format the input selection level for displaying.
 *
 * @export
 * @param {string} sl input selection level.
 * @returns {string} the user friendly for displaying on screen.
 */
export function formatSelectionLevel(sl?: string): string {
  switch (sl) {
    case 'one-or-more':
      return 'one or more options';
    case 'two-or-more':
      return 'two or more options';
    case 'exactly-1':
      return 'exactly one option';
    case 'exactly-2':
      return 'exactly two options';
    case 'exactly-3':
      return 'exactly three options';
    case '0-3-options':
      return 'max three options';
    default:
      return '';
  }
}

/**
 * Return true if the give selection level has at least 1 required option count.
 *
 * @export
 * @param {string} sl input selection level.
 * @returns {boolean} true if the give selection level has at least 1 required option count.
 */
export function isRequiredSelectionLevel(sl?: string): boolean {
  return requiredOptionCountForSelectionLevel(sl) > 0;
}

/**
 * Return the max option count for given selection level
 *
 * @export
 * @param {string} sl input selection level.
 * @returns {number} max option count.
 */
export function maxOptionCountForSelectionLevel(sl?: string): number {
  switch (sl) {
    case 'exactly-1':
      return 1;
    case 'exactly-2':
      return 2;
    case 'exactly-3':
      return 3;
    case '0-3-options':
      return 3;
    default:
      return 0;
  }
}

/**
 * Return the number of required option corresponding to given selection level.
 *
 * @export
 * @param {string} sl input selection level.
 * @returns {number} required option count.
 */
export function requiredOptionCountForSelectionLevel(sl?: string): number {
  switch (sl) {
    case 'one-or-more':
      return 1;
    case 'two-or-more':
      return 2;
    case 'exactly-1':
      return 1;
    case 'exactly-2':
      return 2;
    case 'exactly-3':
      return 3;
    default:
      return 0;
  }
}
